import { ChevronDown } from "lucide-react";
import { cn } from "../../lib/utils";

// ظل 3D بارز مطابق لبطاقات الصفحة الرئيسية — ليبدو الحقل واضحاً أنه قابل للضغط.
export const NEU_3D = {
  boxShadow:
    "0 10px 20px rgba(0,0,0,0.26), 0 6px 8px rgba(0,0,0,0.16),"
    + " inset 0 1.5px 0 rgba(255,255,255,0.45), inset 0 -3px 8px rgba(0,0,0,0.14)",
};

// قائمة اختيار بارزة (3D Neu) مع سهم واضح — تُستخدم في الفلاتر على الهاتف والحاسوب.
export const NeuPicker = ({ className, children, testId, ...rest }) => (
  <div className={cn("relative", className)}>
    <select
      data-testid={testId}
      style={NEU_3D}
      className={cn(
        "h-12 w-full appearance-none rounded-2xl bg-background ps-4 pe-10 text-sm font-bold",
        "text-foreground transition-[box-shadow,transform] duration-300 hover:-translate-y-0.5",
        "active:translate-y-0 active:shadow-neu-in focus:outline-none focus:ring-2 focus:ring-ring",
      )}
      {...rest}
    >
      {children}
    </select>
    <span className="pointer-events-none absolute inset-y-0 end-3 flex items-center">
      <ChevronDown className="h-4 w-4 text-primary" strokeWidth={3} />
    </span>
  </div>
);
